import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {atom, useAtom, useSetAtom} from "jotai";
import {toast, ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {
    Arrow, BodyContainer,
    ButtonGroup,
    Logo,
    SignUpContents,
    SignUpHeader,
    Step,
    StepContainer,
    Steps,
} from "./styles";
import Terms from "./Terms";
import {nextStepAtom} from "./entity/entity";
import Done from "./Done";
import Basic from "./Basic";

export default function SignUp() {
  const [agreeValidation] = useAtom(nextStepAtom)
  const navigate = useNavigate()
  const [steps, setStep] = useState({
    step1: false,
    step2: false,
    step3: false
  })
  const handleNextStep = () => {
    if (agreeValidation.terms) {
      if (!steps.step1 && !steps.step2 && !steps.step3) {
        setStep({
          step1: true,
          step2: false,
          step3: false
        })
      }
    } else {
      toast.warning('전체 약관이 동의가 되지 않았습니다.')
    }
    if (agreeValidation.terms && !agreeValidation.validation) {
      if (steps.step1 && !steps.step2 && !steps.step3) {
        setStep({
          step1: true,
          step2: true,
          step3: false
        })
      }
    }
    if (agreeValidation.terms && agreeValidation.validation) {
      if (steps.step1 && !steps.step2 && !steps.step3) {
        setStep({
          step1: true,
          step2: true,
          step3: true
        })
      }
    }
  }
  return (
    <div className={'sign-up'}>
      <SignUpHeader>
        <article>
          <Link to={'/'}>
            <Logo/>
          </Link>
        </article>
      </SignUpHeader>
      <BodyContainer>
          <StepContainer>
            <article>
              <div><h1>회원 가입</h1></div>
              <div><p>회원가입 하시면 Oaple에 다양한 서비스를 이용하실 수 있습니다.</p></div>
              <Steps>
                <Step $active>
                  <div style={{backgroundImage: `url("/assets/images/join/icon_membership_step01_on.png")`}}></div>
                  <div>
                    <h3>STEP 01</h3>
                    <p>약관 동의</p>
                  </div>
                </Step>
                <Arrow/>
                <Step $active={steps.step1}>
                  <div
                      style={{backgroundImage: `url("/assets/images/join/icon_membership_step02_${steps.step1 ? 'on' : 'off'}.png")`}}></div>
                  <div>
                    <h3>STEP 02</h3>
                    <p>기본 정보 입력</p>
                  </div>
                </Step>
                <Arrow/>
                <Step $active={steps.step2}>
                  <div
                      style={{backgroundImage: `url("/assets/images/join/icon_membership_step03_${steps.step2 ? 'on' : 'off'}.png")`}}></div>
                  <div>
                    <h3>STEP 03</h3>
                    <p>회원 가입 완료</p>
                  </div>
                </Step>
              </Steps>
            </article>
          </StepContainer>
          <SignUpContents>
            {!steps.step1 && !steps.step2 && !steps.step3 &&
              <>
                <Terms/>
                <ButtonGroup $sticky>
                  <button type={'button'} onClick={() => window.history.back()}>취소</button>
                  <button type={'button'} onClick={handleNextStep}>다음</button>
                </ButtonGroup>
              </>
            }
            {steps.step1 && !steps.step2 && !steps.step3 &&
              <Basic nextStep={handleNextStep} onCancel={() => navigate('/login')}/>
            }
            {steps.step1 && steps.step2 && !steps.step3 &&
              <div className={'done'}>
                <Done/>
                <ButtonGroup>
                  {/* eslint-disable-next-line no-restricted-globals */}
                  <button onClick={() => location.replace('/')}>로그인하기</button>
                </ButtonGroup>
              </div>
            }
          </SignUpContents>
          <ToastContainer
            position="top-center"
            autoClose={1500}
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            limit={1}
            style={{zIndex: 9999999}}
          />
      </BodyContainer>
    </div>
  )
}